/**
 * Label for the audit footer's "· <user>" segment.
 *
 * `created_by` stores a platform user id (32-hex). Never render that raw id —
 * either resolve it via `resolve` (current session user) or omit the segment.
 * Non-id strings (email / display name, if a future enricher writes them) pass
 * through unchanged.
 */
export function formatAuditCreatedBy(
  value: unknown,
  resolve?: { id?: string | null; label?: string | null },
): string {
  if (value === null || value === undefined || value === '') return ''
  const s = String(value).trim()
  if (!s) return ''
  const label = (resolve?.label || '').trim()
  if (resolve?.id != null && String(resolve.id) === s && label) {
    return label
  }
  if (/^[0-9a-fA-F]{32}$/.test(s)) return ''
  return s
}
